import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { getUsersApi, type UserOption } from '@/services/users'

export interface UsersState {
  items: UserOption[]
  status: 'idle' | 'loading' | 'succeeded' | 'failed'
}

const initialState: UsersState = {
  items: [],
  status: 'idle',
}

export const fetchUsers = createAsyncThunk(
  'users/fetchUsers',
  async (_, { rejectWithValue }) => {
    const response = await getUsersApi()
    if (!response.success) {
      return rejectWithValue(response.message ?? 'Unable to fetch users')
    }
    return response.data as UserOption[]
  }
)

const usersSlice = createSlice({
  name: 'users',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchUsers.pending, (state) => {
        state.status = 'loading'
      })
      .addCase(fetchUsers.fulfilled, (state, action) => {
        state.status = 'succeeded'
        state.items = action.payload
      })
      .addCase(fetchUsers.rejected, (state) => {
        state.status = 'failed'
      })
  },
})

export default usersSlice.reducer
